export default "__VITE_ASSET__GtNPr27K__"